import AntRadio, { type RadioGroupProps as AntRadioGroupProps, type RadioProps as AntRadioProps } from "antd/lib/radio";
import { RadioButtonProps as AntRadioButtonProps } from "antd/lib/radio/radioButton";
import { FC } from "react";

export type RadioProps = AntRadioProps;
export type RadioButtonProps = AntRadioButtonProps;
export type RadioGroupProps = AntRadioGroupProps;

export const Radio: FC<RadioProps> & {
    Button: FC<RadioButtonProps>;
    Group: FC<RadioGroupProps>;
} = props => {
    return <AntRadio {...props} />;
};

Radio.Button = AntRadio.Button;
Radio.Group = AntRadio.Group;
